module.exports = __webpack_public_path__ + "media/images/emblems/Dierikon_LU-d4c164321fb82ce57eeb49ea8927fd25.png";